import './YoutubeVideo.scss';
import template from './YoutubeVideo.vhtml';
import playIcon from '../../../_svg/icon-play.svg';

export default {
	name: 'YoutubeVideo',
	template: template,
	components: {
		playIcon,
	},
	props: {
		videoId: {
			type: String,
			default: '',
		},
		thumbnail: {
			type: Object,
			default: null,
		},
		caption: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		playerVars: {
			autoplay: 0,
			rel: 0,
			showinfo: 0,
			origin: 'https://gi.lndo.site',
			host: 'https://www.youtube.com',
		},
		player: null,
		isPlaying: false,
		hasLoaded: false,
		initialClick: false,
		isShown: true,
	}),
	computed: {
		hasId: vm => vm.videoId.length > 0,
		hasThumbnail: vm => vm.thumbnail !== null,
		youtubeVideoInnerClasses: vm => [
			'youtube-video__inner',
			{
				'youtube-video__inner--transparent-top': !vm.isShown && vm.hasThumbnail,
				'youtube-video__inner--has-overlay': !vm.isPlaying,
			},
		],
	},
	watch: {
		hasLoaded() {
			this.play();
		},
	},
	methods: {
		ready(e) {
			this.player = e.target;
		},
		playing(e) {
			this.hasLoaded = true;
		},
		play() {
			if (this.initialClick) {
				this.isPlaying = true;
				setTimeout(() => {
					this.player.playVideo();
				}, 900);
			} else {
				this.initialClick = true;
				this.isPlaying = true;
				this.player.playVideo();
			}
		},
		pause() {
			this.player.pauseVideo();
			this.$options.delayAnimation = setTimeout(() => {
				this.isPlaying = false;
			}, 100);
		},
		buffering() {
			clearTimeout(this.$options.delayAnimation);
		},
		ended() {
			this.isPlaying = false;
		},
	},
};
